(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruphay-hero-premium"] && !Shopify.designMode) return;
  try {
    
(function () {
  var controllers = new WeakMap();

  function init(root) {
    if (!root || controllers.has(root)) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rp-slide]'));
    if (!slides.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rp-dot]'));
    var prev = root.querySelector('[data-rp-prev]');
    var next = root.querySelector('[data-rp-next]');
    var current = root.querySelector('[data-rp-current]');
    var index = 0, timer = null, touchX = null;
    var hovered = false, focused = false, inView = true, selectedInEditor = false;
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = Math.max(3000, Number(root.dataset.interval) || 6000);
    var observer = null;

    function stop() { if (timer !== null) { clearInterval(timer); timer = null; } }

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        if (active) {
          slide.removeAttribute('inert');
          // Solicita la siguiente imagen aunque tuviera lazy loading.
          var image = slide.querySelector('img');
          if (image) image.loading = 'eager';
        } else {
          slide.setAttribute('inert', '');
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    }

    function play() {
      stop();
      if (!autoplay || slides.length < 2 || mq.matches || document.hidden ||
          hovered || focused || !inView || selectedInEditor) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }
    function move(n) { show(n); play(); }
    function onPrev() { move(index - 1); }
    function onNext() { move(index + 1); }
    function onMouseEnter() { hovered = true; stop(); }
    function onMouseLeave() { hovered = false; play(); }
    function onFocusIn() { focused = true; stop(); }
    function onFocusOut(e) {
      if (!root.contains(e.relatedTarget)) { focused = false; play(); }
    }
    function onTouchStart(e) { touchX = e.changedTouches[0].screenX; stop(); }
    function onTouchEnd(e) {
      if (touchX !== null) {
        var diff = e.changedTouches[0].screenX - touchX;
        if (Math.abs(diff) > 45) show(index + (diff < 0 ? 1 : -1));
      }
      touchX = null; play();
    }
    function onTouchCancel() { touchX = null; play(); }
    function onVisibility() { play(); }
    function onMotionChange() { play(); }
    function onKeyDown(e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        if (!root.contains(document.activeElement)) return;
        e.preventDefault();
        move(index + (e.key === 'ArrowRight' ? 1 : -1));
      }
    }
    var dotHandlers = [];
    dots.forEach(function (dot, i) {
      var click = function () { move(i); };
      dot.addEventListener('click', click);
      dotHandlers.push(click);
    });
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    root.addEventListener('mouseenter', onMouseEnter);
    root.addEventListener('mouseleave', onMouseLeave);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    root.addEventListener('touchstart', onTouchStart, { passive: true });
    root.addEventListener('touchend', onTouchEnd, { passive: true });
    root.addEventListener('touchcancel', onTouchCancel, { passive: true });
    root.addEventListener('keydown', onKeyDown);
    document.addEventListener('visibilitychange', onVisibility);
    if (mq.addEventListener) mq.addEventListener('change', onMotionChange);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting; play();
      }, { threshold: 0.05 });
      observer.observe(root);
    }
    show(0);
    play();

    controllers.set(root, {
      showBlock: function (blockId) {
        var i = slides.findIndex(function (slide) { return slide.dataset.blockId === blockId; });
        if (i >= 0) { selectedInEditor = true; show(i); stop(); }
      },
      deselect: function () { selectedInEditor = false; play(); },
      pause: function () { selectedInEditor = true; stop(); },
      destroy: function () {
        stop(); if (observer) observer.disconnect();
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        dots.forEach(function (dot, i) { dot.removeEventListener('click', dotHandlers[i]); });
        root.removeEventListener('mouseenter', onMouseEnter);
        root.removeEventListener('mouseleave', onMouseLeave);
        root.removeEventListener('focusin', onFocusIn);
        root.removeEventListener('focusout', onFocusOut);
        root.removeEventListener('touchstart', onTouchStart);
        root.removeEventListener('touchend', onTouchEnd);
        root.removeEventListener('touchcancel', onTouchCancel);
        root.removeEventListener('keydown', onKeyDown);
        document.removeEventListener('visibilitychange', onVisibility);
        if (mq.removeEventListener) mq.removeEventListener('change', onMotionChange);
        controllers.delete(root);
      }
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-rp-hero]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-rp-hero]'));
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-rp-hero]');
    var controller = root && controllers.get(root);
    if (controller) controller.destroy();
  });
  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-rp-hero]');
    var controller = root && controllers.get(root);
    if (controller) controller.pause();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var root = event.target.querySelector('[data-rp-hero]');
    var controller = root && controllers.get(root);
    if (controller) controller.deselect();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-rp-slide]');
    var root = slide && slide.closest('[data-rp-hero]');
    var controller = root && controllers.get(root);
    if (controller) controller.showBlock(event.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-rp-hero]');
    var controller = root && controllers.get(root);
    if (controller) controller.deselect();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
